import { AccountTypeID } from "../../config/Constants"
import { Filter, Sort } from "../GridRequest"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { SelectionInboxGridResponse } from "./SelectionInboxModel/SelectionInboxGridResponse"

function columnFilters(filters: Filter[]) {
  return {
      AuthorizationID: filters.find(filter => filter.column === "AuthorizationID")?.values || [],
      Company: filters.find(filter => filter.column === "Company")?.values || [],
      Location: filters.find(filter => filter.column === "Location")?.values || [],
      EventDate: filters.find(filter => filter.column === "EventDate")?.values || [],
      IDNumber: filters.find(filter => filter.column === "IDNumber")?.values || [],
      Name: filters.find(filter => filter.column === "Name")?.values || [],
      NotificationDate: filters.find(filter => filter.column === "NotificationDate")?.values || [],
      Pool: filters.find(filter => filter.column === "Pool")?.values || [],
      Regulated: filters.find(filter => filter.column === "Regulated")?.values || [],
      Selection: filters.find(filter => filter.column === "Selection")?.values || [],
      Service: filters.find(filter => filter.column === "Service")?.values || [],
      Site: filters.find(filter => filter.column === "Site")?.values || [],
      Status: filters.find(filter => filter.column === "Status")?.values || [],
      Occupation: filters.find(filter => filter.column === "Occupation")?.values || [],
      RegulatoryMode: filters.find(filter => filter.column === "RegulatoryMode")?.values || [],
      LastName: filters.find(filter => filter.column === "LastName")?.values || [],
      MiddleInitial: filters.find(filter => filter.column === "MiddleInitial")?.values || [],
      FirstName: filters.find(filter => filter.column === "FirstName")?.values || [],
      Gender: filters.find(filter => filter.column === "Gender")?.values || [],
      DateOfBirth: filters.find(filter => filter.column === "DateOfBirth")?.values || [],
      PrimaryIDType: filters.find(filter => filter.column === "PrimaryIDType")?.values || [],
      SSN: filters.find(filter => filter.column === "SSN")?.values || [],
      DriverID: filters.find(filter => filter.column === "DriverID")?.values || [],
      EmployerID: filters.find(filter => filter.column === "EmployerID")?.values || [],
      AlternateID: filters.find(filter => filter.column === "AlternateID")?.values || [],
      CRMUniqueID: filters.find(filter => filter.column === "CRMUniqueID")?.values || [],
      HireDate: filters.find(filter => filter.column === "HireDate")?.values || [],
      TerminationDate: filters.find(filter => filter.column === "TerminationDate")?.values || [],
      CellPhone: filters.find(filter => filter.column === "CellPhone")?.values || [],
      HomePhone: filters.find(filter => filter.column === "HomePhone")?.values || [],
      WorkPhone: filters.find(filter => filter.column === "WorkPhone")?.values || [],
      Inactive: filters.find(filter => filter.column === "Inactive")?.values || [],
      RetireDate: filters.find(filter => filter.column === "StRetireDateatus")?.values || [],
      Supervisor1: filters.find(filter => filter.column === "Supervisor1")?.values || [],
      Supervisor2: filters.find(filter => filter.column === "Supervisor2")?.values || [],
      Address: filters.find(filter => filter.column === "Address")?.values || [],
      Province: filters.find(filter => filter.column === "Province")?.values || [],
      Zip: filters.find(filter => filter.column === "Zip")?.values || [],
      Country: filters.find(filter => filter.column === "Country")?.values || [],
      StateCode: filters.find(filter => filter.column === "StateCode")?.values || [],
      StateName: filters.find(filter => filter.column === "StateName")?.values || [],
      Manager: filters.find(filter => filter.column === "Manager")?.values || [],
  }
}

function gridParams(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }): string {
  return JSON.stringify({
      AccountTypeID: AccountTypeID,
      ColumnFilters: columnFilters(filters),
      DateFrom: "1/01/0001 00:00:00",
      DateTo: "1/01/0001 00:00:00",
      Exact: false,
      Filters: {
          Company: [],
          DateRange: "",
          DateType: "",
          EndDate: "",
          Location: [],
          Reason: [],
          Region: [],
          Regulated: "Regulated & Non-Regulated",
          Service: [],
          StartDate: "",
          Status: "In Process"
      },
      IsSearch: true, // TODO: verify
      IsMarketPlace: true,
      Mask: search.text || "",
      PageNumber: pageNumber,
      PageSize: pageSize || 20,
      Pending: true,
      RoleID: 0,    // TODO: verify
      TrackPersonID: [{Mask: "", TestDetailID: "", MockTestDetailID: 0}],  // TODO: verify
      SearchBy: search.field || "",
      SortGrid: { SortColumn: sort?.column || "", SortOrder: sort?.order.toUpperCase() === "DESC" ? "DSC" : sort?.order.toUpperCase() },
      Type: "All"
  })
}
export const SelectionInboxGridObservable = (pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }) => ObservableFromFetch<SelectionInboxGridResponse>("RandomTest/GetRandomResult", gridParams(pageNumber, pageSize, sort, filters, search))
export const SelectionInboxGridCsv = (pageNumber: number, pageSize: number, sort: Sort, filters: Filter[], search: { field: string, text: string }) => ObservableFromFetch<string>("RandomTest/ExportRandomTrackRecord", gridParams(pageNumber, pageSize, sort, filters, search))
